
import React from "react";
import "./VirasatV2DefaultHomePage.scss"
import Button from "../../components/Button/Button";

import ImageCarousel from "../../components/ImageCarousel/ImageCarousel";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";

const VirasatV2DefaultExpPage = ({ components }) => {
    const dispatch = useDispatch()

    const getLeftComponent = (component) => {
        switch (component.ID) {
            case "VirasatDefaultExpPage-since":
                return <div className="since-text-story">- {component?.Props?.text} -</div>

            case "VirasatDefaultExpPage-header":
                return <div className="VirasatV2DefaultExpPage-container-title">{component?.Props?.header}</div>

            case "VirasatDefaultExpPage-paragraph":
                return component?.Data?.map((text, key) => {
                    return (
                        <div className="VirasatV2DefaultExpPage-container-text-cont" key={key}>
                            {text.text}
                        </div>
                    )
                })
            case "VirasatDefaultExpPage-button":
                return <div className="VirasatV2DefaultExpPage-btn-cont">
                    <Button
                        text={component?.Props?.text}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href !== "") {
                                if (component?.Props?.href?.includes("https://")) {
                                    window.open(component?.Props?.href, '_blank')
                                } else {
                                    window.location.href = component?.Props?.href && component?.Props?.href !== "" ? component?.Props?.href : "/"
                                }
                            }
                            else {
                                dispatch(setIsComing(true))
                            }

                        }}
                    />
                </div>
            default:
                return <div />
        }
    }
    const leftContent = (leftComponents) => {
        return (
            <div className="VirasatV2DefaultExpPage-container-left">
                {sortByOrderAscending(leftComponents).map((component, key) => {
                    return (
                        getLeftComponent(component)
                    )
                })}

            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultExpPage-left":
                return leftContent(component?.Components)
            case "VirasatDefaultExpPage-icon":
                return <div className="VirasatV2DefaultExpPage-container-icon">
                    <div className="VirasatV2DefaultExpPage-container-icon-inner">
                        <img alt="" src={component?.Props?.icon} />
                    </div>

                </div>
            case "VirsatDefaultStoryPage-icon":
                return <div className="VirasatV2DefaultExpPage-container-icon">
                    <div className="VirasatV2DefaultExpPage-container-icon-inner">
                        <img alt="" src={component?.Props?.icon} />
                    </div>

                </div>
            case "VirasatDefaultExpPage-right":
                return <div className="VirasatV2DefaultExpPage-container-right">
                    <ImageCarousel
                        content={component?.Data}
                        height={window.screen.width < 1200 ? "477px" : "900px"} />
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatV2DefaultExpPage" >
            <div className="VirasatV2DefaultExpPage-container">
                {sortByOrderAscending(components).map((component, key) => {
                    console.log(components, "com")
                    return (
                        getComponents(component)
                    )
                })}

            </div>
        </div>
    )
}
export default VirasatV2DefaultExpPage